// extracted by mini-css-extract-plugin
module.exports = {"Title":"Logbook_Title__2XNRb","PlusButton":"Logbook_PlusButton__1nkgk"};